import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { MessageService } from 'primeng/api';

@Injectable({ providedIn: 'root' })
export class NotificationService {

    constructor(public messageService: MessageService) {
    }

    showSuccess(message: string) {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: message });
    }

    showError(message: string) {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: message });
    }

    showWarning(message: string) {
        this.messageService.add({ severity: 'warning', summary: 'Warning', detail: message });
    }

    showInfo(message: string) {
        this.messageService.add({ severity: 'info', summary: 'Info', detail: message });
    }

    showErrorFromResponse(res: any, defaultResponse: string) {
        let message;
        if (res && res.errors && res.errors.length) {
            message = (<any>res.errors[0]).reason || res.errors[0].message;
        } else {
            const err: Error = <any>res;
            console.error(err);
            message = err.message;
        }
        if (!message) message = _.get(res, 'error.message');
        if (message) {
            for (const [key, value] of Object.entries(this.fieldNameToName)) {
                if (message.includes(key)) message = message.replace(key, value);
            }
            if (res && res.errors && res.errors.length && res.errors[0].systemMessage) {
                for (const [key, value] of Object.entries(this.fieldNameToName)) {
                    if (message.includes(key)) message = message.replace(key, value);
                }
            }
            if (message === "Duplicate key found.") {
                if (res.errors[0].systemMessage) {
                    message = "Phone number or Email address already exists";
                }
            }
        }
        this.showError(message || defaultResponse);
    }

    fieldNameToName = {
        pro_profileId_str: "Profile ID",
        pro_registration_number_str: "Registration Number",
        pro_middle_name_str: "Middle Name",
        pro_aadhar_number_num: "Aadhar Number",
        pro_secondary_number_num: "Second Number",
        pro_address_str: "Address",
        pro_cor_address_str: "Correspondence Address",
        pro_cor_city_str: "Correspondence City",
        pro_father_name_str: "Father name",
        pro_mother_name_str: "Mother name",
        pro_account_number_num: "Account Number",
        pro_name_of_acc_holder_str: "Name of account holder",
        pro_ifsc_code_str: "IFSC Code",
        pro_branch_name_str: "Branch Name",
        pro_pan_number_str: "PAN Number",
        usr_mobile_number_num: "Mobile number",
        usr_email_str: "Email id",
    }
}
